import React, { useEffect } from 'react';

import { Spin } from 'antd';
import { Moment } from 'moment';

import { useCompanyWorkSchedule } from '@hooks/useCompanyWorkSchedule';
import { DateRangeCalendar } from '@molecules/dateRangeCalendar/dateRangeCalendar';
import { useDateRangeSelection } from '@molecules/dateRangeCalendar/hooks/useDateRangeSelection';

import { OrderDatesHeader } from '../../../../orderProfile/components/orderCreateHeader/components/orderDatesHeader';

import './style.scss';

interface Props {
    startDate: Moment;
    setStartDate: (date: Moment) => void;
    /** Окончание записи необязательно: `null` — заказ создаётся без него */
    finishDate: Moment | null;
    setFinishDate: (date: Moment | null) => void;
}

type TRangeProps = Props & { schedule: ReturnType<typeof useCompanyWorkSchedule>['schedule'] };

/**
 * Календарь монтируется на каждый заход на шаг и стартует с дат мастера,
 * а каждое изменение выбора сразу отдаёт обратно — их отправит «Создать заказ».
 */
const StartDateRange = ({ startDate, setStartDate, finishDate, setFinishDate, schedule }: TRangeProps) => {
    const range = useDateRangeSelection(startDate?.toDate(), finishDate?.toDate());
    const { start, end } = range.selection;

    useEffect(() => {
        if (start) setStartDate(start);
        setFinishDate(end);
    }, [start, end]);

    return (
        <DateRangeCalendar
            range={range}
            schedule={schedule}
            // Та же шапка, что в заказе: новый заказ получит плановые даты
            renderHeader={(headerProps) => <OrderDatesHeader kind="planned" {...headerProps} />}
        />
    );
};

export const StartDateStep: React.FC<Props> = (props) => {
    const { schedule, isLoading } = useCompanyWorkSchedule();

    return (
        <div className="start-date__wrapper">
            {/* Пока график грузится, сетку не рисуем: она перестроится под пальцем */}
            {isLoading ? <Spin /> : <StartDateRange {...props} schedule={schedule} />}
        </div>
    );
};
